/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import { Contract, ContractFactory, Interface, } from "ethers";
const _abi = [
    {
        inputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        name: "canCreatePoll",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "pure",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32",
            },
            {
                internalType: "address",
                name: "",
                type: "address",
            },
            {
                internalType: "bytes",
                name: "",
                type: "bytes",
            },
        ],
        name: "canVoteOnPoll",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "pure",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32",
            },
        ],
        name: "onPollClosed",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32",
            },
            {
                internalType: "address",
                name: "",
                type: "address",
            },
            {
                internalType: "bytes",
                name: "",
                type: "bytes",
            },
        ],
        name: "onPollCreated",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "proposalId",
                type: "bytes32",
            },
        ],
        name: "onPollDestroyed",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes4",
                name: "interfaceId",
                type: "bytes4",
            },
        ],
        name: "supportsInterface",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "pure",
        type: "function",
    },
];
const _bytecode = "0x60808060405234601557610234908161001b8239f35b600080fdfe608080604052600436101561001357600080fd5b60003560e01c90816301ffc9a714610125575080634836cc44146101205780638d74950e14610120578063a4b4bbda146100d0578063c60e2047146100945763ff6fef7d1461006157600080fd5b3461008f57604036600319011261008f5761007a61018e565b506100836101ba565b50602060405160018152f35b600080fd5b3461008f57606036600319011261008f576100ad6101ba565b5060443567ffffffffffffffff811161008f576100ce9036906004016101d0565b005b3461008f57608036600319011261008f576100e961018e565b506100f26101a4565b5060643567ffffffffffffffff811161008f576101139036906004016101d0565b5050602060405160018152f35b61017b565b3461008f57602036600319011261008f576004359063ffffffff60e01b821680920361008f5760209163a7f8c2d760e01b8114908115610167575b5015158152f35b60016290108360e01b031914905083610160565b3461008f57602036600319011261008f57005b600435906001600160a01b038216820361008f57565b604435906001600160a01b038216820361008f57565b602435906001600160a01b038216820361008f57565b9181601f8401121561008f5782359167ffffffffffffffff831161008f576020838186019501011161008f5756fea2646970667358221220d246fd2c53ce9d8933373896f4244a3a6341b91af0ef5222658b5db5d9213f9664736f6c634300081c0033";
const isSuperArgs = (xs) => xs.length > 1;
export class AllowAllACL__factory extends ContractFactory {
    constructor(...args) {
        if (isSuperArgs(args)) {
            super(...args);
        }
        else {
            super(_abi, _bytecode, args[0]);
        }
    }
    getDeployTransaction(overrides) {
        return super.getDeployTransaction(overrides || {});
    }
    deploy(overrides) {
        return super.deploy(overrides || {});
    }
    connect(runner) {
        return super.connect(runner);
    }
    static createInterface() {
        return new Interface(_abi);
    }
    static connect(address, runner) {
        return new Contract(address, _abi, runner);
    }
}
AllowAllACL__factory.bytecode = _bytecode;
AllowAllACL__factory.abi = _abi;
//# sourceMappingURL=AllowAllACL__factory.js.map